function initCartDrawerSwiper() {
  if (window.innerWidth > 767) {
    new Swiper(".cartDrawer-carousel", {
      slidesPerView: 2,
      spaceBetween: 6,
      slidesPerGroup: 2,
      loop: false,
      autoHeight: false,
      centerInsufficientSlides: true,
      resistance: false,            // disable resistance/bounce at edges
      resistanceRatio: 0.6,           // set ratio to 0 for no bounce effect
      touchMoveStopPropagation: true, // stop touchmove propagation up
      freeMode: {
        enabled: true,     // enables free scrolling
      },
      navigation: {
        nextEl: ".slider-button--next",
        prevEl: ".slider-button--prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}

function initVisualNavigationSwiper() {
  if (window.innerWidth > 767) {
    new Swiper(".visualNavigation-carousel", {
      slidesPerView: 6.5,
      spaceBetween: 25,
    });
  }
}

function initMobileSwiper() {
  if (window.innerWidth <= 767) {
    new Swiper(".mobileSwiper-carousel", {
      slidesPerView: 2,
      spaceBetween: 6,
      slidesPerGroup: 2,
      loop: false,
      autoHeight: false,
      centerInsufficientSlides: true,
      resistance: false,            // disable resistance/bounce at edges
      resistanceRatio: 0.6,           // set ratio to 0 for no bounce effect
      touchMoveStopPropagation: true, // stop touchmove propagation up
      freeMode: {
        enabled: true,     // enables free scrolling
      },
      navigation: {
        nextEl: ".slider-button--next",
        prevEl: ".slider-button--prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}